import { Group, TextInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import { freightFormMessages } from './freight-form-messages';
import { US_STATES } from '../../../../constants/us-states';
import { Dropdown } from '../../../common/Dropdown';

import type { FreightBrowserDestination } from '../../freight-browser-types';

type ShipToSectionProps = {
  value: FreightBrowserDestination;
  onChange: (next: FreightBrowserDestination) => void;
};

export const ShipToSection = ({ value, onChange }: ShipToSectionProps) => {
  const intl = useIntl();

  return (
    <Group grow>
      <TextInput
        data-testid='destination-city'
        label={intl.formatMessage(freightFormMessages.cityLabel)}
        onChange={(e) => onChange({ ...value, city: e.currentTarget.value })}
        value={value.city}
      />
      <Dropdown
        data={US_STATES}
        data-testid='destination-state'
        label={intl.formatMessage(freightFormMessages.stateLabel)}
        onChange={(val) => onChange({ ...value, state: val ?? '' })}
        placeholder={intl.formatMessage(freightFormMessages.statePlaceholder)}
        searchable
        value={value.state || null}
      />
      <TextInput
        data-testid='destination-zip'
        label={intl.formatMessage(freightFormMessages.postalCodeLabel)}
        onChange={(e) => onChange({ ...value, postalCode: e.currentTarget.value })}
        value={value.postalCode}
      />
    </Group>
  );
};
